// @flow
import ConceptLinkModel from "./ConceptLinkModel";
import LinkModel from "../links/LinkModel";

import { getBasePathModularUI } from "../../constants";

import type {
  IModelWithChildModels,
  ModularUIModel,
  textfragmentJSON,
  propertyJSON,
  ModelOptions,
} from "../types";

/**
 * Concept relation model
 */
export default class ConceptRelationModel implements IModelWithChildModels {
  _relation: Object;
  _modelOptions: ModelOptions;
  _concept: ConceptLinkModel;

  /**
   */
  constructor(
    relation: Object,
    entryDate: ?ISO_DATE = null,
    modelOptions?: ModelOptions,
  ) {
    this._relation = relation;
    this._modelOptions = modelOptions || {
      origin: "",
      contextPath: getBasePathModularUI(),
    };

    if (relation && relation.concept) {
      this._concept = new ConceptLinkModel(
        relation.concept,
        entryDate,
        this._modelOptions,
      );
    }
  }

  /**
   */
  getInitialChildModelLinks(): Array<LinkModel> {
    return this.concept.getInitialChildModelLinks();
  }

  /**
   */
  setChildModels(models: Array<ModularUIModel>) {
    this.concept.setChildModels(models);
  }

  /**
   */
  get type(): string {
    return this._relation.relationType;
  }

  /**
   * Get key of relation
   */
  get key(): string {
    return this.type;
  }

  /**
   * Get Label of relation
   */
  get label(): string {
    return this._relation.relationLabel;
  }

  /**
   * Get direction of relation
   */
  get direction(): string {
    return this._relation.relationDirection;
  }

  /**
   * Get type of relation type,
   */
  get relationTypeType():
    | "None"
    | "Sub-Class"
    | "Composition"
    | "Association"
    | "Unknown" {
    return this._relation.relationTypeType ?? "Unknown";
  }

  /**
   */
  get condition(): string {
    return this._relation.relationCondition;
  }

  /**
   * Get other concept
   */
  get concept(): ConceptLinkModel {
    return this._concept;
  }

  /**
   * Set concept information
   */
  set concept(concept: ConceptLinkModel) {
    this._concept = concept;
  }

  /**
   * Get Text fragments
   */
  get textfragments(): Array<textfragmentJSON> {
    return this._relation.textFragments;
  }

  /**
   * Get Properties
   */
  get properties(): Array<propertyJSON> {
    return this._relation.properties;
  }
}
